import { FinalishReviewBridge } from './bridge';
import { FinalishLauncher } from './launcher';
import { FinalishTopLevelConnector } from './top-level';
import type { FinalishHostIdentity } from './types';

declare global {
  interface Window {
    Finalish?: {
      bridge?: FinalishReviewBridge;
      launcher?: FinalishLauncher;
      topLevel?: FinalishTopLevelConnector;
      identify?: (identity: FinalishHostIdentity | null) => void;
      open?: () => Promise<void>;
      close?: () => void;
    };
  }
}

const script = document.currentScript as HTMLScriptElement | null;
const parentOrigins = (script?.dataset.finalishParentOrigins ?? '')
  .split(',')
  .map((value) => value.trim())
  .filter(Boolean);
const reviewOrigins = (
  script?.dataset.finalishReviewOrigins ??
  script?.dataset.finalishParentOrigins ??
  ''
)
  .split(',')
  .map((value) => value.trim())
  .filter(Boolean);
const projectId = script?.dataset.finalishProjectId?.trim() ?? '';
const apiUrl = script?.dataset.finalishApiUrl?.trim() || 'https://api.finalish.ru';
const appUrl = script?.dataset.finalishAppUrl?.trim() || 'https://finalish.ru';
const hostUserId = script?.dataset.finalishUserId?.trim() ?? '';
const hostUserName = script?.dataset.finalishUserName?.trim() ?? '';
const hostUserEmail = script?.dataset.finalishUserEmail?.trim() ?? '';
const dockSide = script?.dataset.finalishDockSide === 'left' ? 'left' : 'right';
const hostIdentity = hostUserId && hostUserId.length <= 200 &&
  hostUserName.length >= 2 && hostUserName.length <= 120
  ? {
      id: hostUserId,
      name: hostUserName,
      ...(isValidEmail(hostUserEmail) ? { email: hostUserEmail } : {}),
    }
  : undefined;

if (window.parent !== window) {
  const bridge = new FinalishReviewBridge({
    allowedParentOrigins: parentOrigins,
  });
  bridge.mount();
  window.Finalish = { ...(window.Finalish ?? {}), bridge };
} else {
  if (projectId && !window.opener) {
    const launcher = new FinalishLauncher({
      projectId,
      apiUrl,
      appUrl,
      identity: hostIdentity,
      dockSide,
    });
    void launcher.mount();
    window.Finalish = {
      ...(window.Finalish ?? {}),
      launcher,
      identify: (identity) => launcher.identify(identity),
      open: () => launcher.open(),
      close: () => launcher.close(),
    };
  }
  if (reviewOrigins.length > 0) {
    const topLevel = new FinalishTopLevelConnector({
      allowedReviewOrigins: reviewOrigins,
      defaultApiUrl: apiUrl,
    });
    topLevel.start();
    window.Finalish = { ...(window.Finalish ?? {}), topLevel };
  }
}

function isValidEmail(value: string): boolean {
  return value.length > 0 && value.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
